// extracted by mini-css-extract-plugin
export default {"viewContent":"RecruitingAnalytics_viewContent__Kw0xA"};